<bootstrap-popup
	[id]="id"
	[title]="'Mes alertes'"
 	[modalSize]="'modal-lg'"
 	[windowCloseButton]="true"
	[displaySubject]="displaySubject"
	(closed)="onWindowClose()"
	>
	
	<div class="panel panel-default">
		<div class="panel-heading"><h3>Alertes</h3></div>
		<div class="pannel-body" *ngIf="user && user.role != 'EXP'">
			<p style="color: red; margin-left: 2em; margin-top: 0.5em;"><strong>Vous devez &ecirc;tre exploitant pour configurer des alertes</strong></p>
		</div>
		<div class="panel-body tablecontainer" *ngIf="user && user.role === 'EXP' && header && rows">
			<table class="table table-striped acces-intervenants" *ngIf="rows.length > 0">
				<thead>
					<tr>
						<th rowspan="2" style="vertical-align: middle;">Parc</th>
						<th colspan="3">Tous</th>
						<th colspan="4">Actions</th>
					</tr>
					<tr>
						<th>
							Tous<br/>
							<input type="checkbox"
								[ngModel]="header.toutesPortees"
								(ngModelChange)="onHeaderToutesPorteesChanged($event)"
								/>
						</th>
						<th>
							Local<br/>
							<input type="checkbox"
								[ngModel]="header.local"
								(ngModelChange)="onHeaderLocalChanged($event)"
								/>
						</th>
						<th>
							Distant<br/>
							<input type="checkbox"
								[ngModel]="header.distant"
								(ngModelChange)="onHeaderDistantChanged($event)"
								/>
						</th>
						<th>
							Toutes<br/>
							<input type="checkbox"
								[ngModel]="header.toutesOperations"
								(ngModelChange)="onHeaderToutesOperationsChanged($event)"
								/>
						</th>
						<th>
							Validation<br/>
							<input type="checkbox"
								[ngModel]="header.validation"
								(ngModelChange)="onHeaderValidationChanged($event)"
								/>
						</th>
						<th>
							Fermeture<br/>
							<input type="checkbox"
								[ngModel]="header.fermeture"
								(ngModelChange)="onHeaderFermetureChanged($event)"
								/>
						</th>
						<th>
							Refus<br/>
							<input type="checkbox"
								[ngModel]="header.refus"
								(ngModelChange)="onHeaderRefusChanged($event)"
								/>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let row of rows">
						<td class="parc">{{ row.parcName }}</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.toutesPortees"
								(ngModelChange)="onToutesPorteesChanged(row, $event)"
								/>
						</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.local"
								(ngModelChange)="onLocalChanged(row, $event)"
								/>
						</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.distant"
								(ngModelChange)="onDistantChanged(row, $event)"
								/>
						</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.toutesOperations"
								(ngModelChange)="onToutesOperationsChanged(row, $event)"
								/>
						</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.validation"
								(ngModelChange)="onValidationChanged(row, $event)"
								/>
						</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.fermeture"
								(ngModelChange)="onFermetureChanged(row, $event)"
								/>
						</td>
						<td>
							<input type="checkbox"
								[ngModel]="row.refus"
								(ngModelChange)="onRefusChanged(row, $event)"
								/>
						</td>
					</tr>
				</tbody>
			</table>
			<div *ngIf="rows.length === 0">
				<strong>Vous n'&ecirc;tes responsable d'aucun parc.</strong>
			</div>
		</div>
	</div>
	
	<div class="text-center actions">
		<button 
			type="button"
			class="btn btn-default"
			(click)="close()"
			>
			Annuler
		</button>&nbsp;
		<button *ngIf="header && rows && rows.length > 0"
			type="button"
			class="btn btn-primary"
			[disabled]="waitingForServer"
			(click)="save()"
			>
			Enregistrer
		</button>
	</div>
</bootstrap-popup>